// extracted by mini-css-extract-plugin
module.exports = {"controlCell":"style_controlCell__vzhD2","lastColumn":"style_lastColumn__3MG7y","scopeCell":"style_scopeCell__3qLpV","fullSizeCell":"style_fullSizeCell__3JG3f"};